/**
 * RTWO Asset & Token Engine — Base Service
 */

import { ASST_ENGINE_VERSION } from '../domain-models';
import type { ASSServiceDescriptor, ASSServiceStatus, IASSService } from '../service-interfaces';
import type { assInternalEventBus } from '../events/ass-event-bus';

export interface ASSServiceContext {
  eventBus: typeof assInternalEventBus;
}

export abstract class BaseASSService implements IASSService {
  abstract readonly serviceId: string;
  abstract readonly serviceName: string;
  abstract readonly description: string;
  abstract readonly integrations: string[];
  abstract readonly requiresLedgerConnection: boolean;
  abstract readonly requiresTokenRuntime: boolean;
  readonly version = ASST_ENGINE_VERSION.version;

  protected status: ASSServiceStatus = 'not_initialized';

  constructor(protected readonly context: ASSServiceContext) {}

  async initialize(): Promise<void> {
    this.status = 'waiting_for_ledger_connection';
  }

  getStatus(): ASSServiceStatus {
    return this.status;
  }

  getDescriptor(): ASSServiceDescriptor {
    return {
      serviceId: this.serviceId,
      serviceName: this.serviceName,
      version: this.version,
      status: this.status,
      description: this.description,
      integrations: this.integrations,
      requiresLedgerConnection: this.requiresLedgerConnection,
      requiresTokenRuntime: this.requiresTokenRuntime,
    };
  }
}
